import React from "react";
import { useTheme } from "styled-components";
import {
  ReducedBar,
  SceneSvg,
  SceneWrap,
  SpinnerArc,
} from "./styles";

// Spinner circular minimalista — anel de fundo cinza + arco accent que gira.
// SVG viewBox 100×100, círculo centrado em (50, 50).
const RADIUS = 36;
const STROKE_WIDTH = 6;
const CENTER = 50;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
// Arco visível = ~25% da circunferência (90°). Resto fica em "gap" (dash).
const ARC_FRACTION = 0.25;
const ARC_LENGTH = CIRCUMFERENCE * ARC_FRACTION;
const GAP_LENGTH = CIRCUMFERENCE - ARC_LENGTH;

export default function SerraCena() {
  const theme = useTheme();

  return (
    <SceneWrap>
      <SceneSvg viewBox="0 0 100 100" role="img" aria-label="Carregando">
        {/* Anel de fundo (estático, sutil) */}
        <circle
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          stroke={theme.border}
          strokeWidth={STROKE_WIDTH}
        />

        {/* Arco accent que rotaciona */}
        <SpinnerArc>
          <circle
            cx={CENTER}
            cy={CENTER}
            r={RADIUS}
            fill="none"
            stroke={theme.accent}
            strokeWidth={STROKE_WIDTH}
            strokeLinecap="round"
            strokeDasharray={`${ARC_LENGTH.toFixed(2)} ${GAP_LENGTH.toFixed(2)}`}
            strokeDashoffset={0}
          />
        </SpinnerArc>
      </SceneSvg>

      <ReducedBar aria-hidden="true">
        <span />
      </ReducedBar>
    </SceneWrap>
  );
}
